module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_106474-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_106474-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847675644_tableofcontents"
    }
  }, [_vm._v("The Dying")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_106474-00001"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("HEN THE BREATHING")]), _vm._v(" got worse he went into the adjacent room and got the copy of Dante. All that night and the night before he had been watching the dying though he didn’t know it was a dying. The grey hairs around the head seemed to panic like the needle of a compass and the eyes, sometimes open, sometimes shut, seemed to be looking at him all the time. He had never seen a dying before. The breathlessness seemed a bit like asthma or bad bronchitis, ascending sometimes into a kind of whistling like a train leaving a station. The voice when it spoke was irritable and petulant. It wanted water, lots of water, milk, lots of milk, anything to quench the thirst and even then he didn’t know it was a dying. The tongue seemed very cold as he fed it milk. It was cold and almost stiff. Once near midnight he saw the cheeks flare up and become swollen so that the eyes could hardly look over them. When a mirror was required to be brought she looked at it, moving her head restlessly this way and that. He knew that the swelling was a portent of some kind, a message from the outer darkness, an omen.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106474-00002"
    }
  }, [_vm._v("Outside, it was snowing steadily, the complex flakes weaving an unintelligible pattern. If he were to put the light out then that other light, as alien as that from a dead planet, the light of the moon itself, would enter the room, a sick glare, an almost abstract light. It would light the pages of the Dante which he needed now more than ever, it would cast over the poetry its hollow glare.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106474-00003"
    }
  }, [_vm._v("He opened the pages but they did not mean anything at all since all the time he was looking at the face. The dying person was slipping away from him. She was absorbed in her dying and he did not understand what was happening. Dying was such an extraordinary thing, such a private thing. "), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("Sometimes he stretched out his hand and she clutched it, and he felt as if he were in a boat and she were in the dark water around it. And all the time the breathing was faster and faster as if something wanted to be away. The brow was cold but the mouth still wanted water. The body was restlessly turning, now on one side now on the other. It was steadily weakening. Something was at it and it was weakening.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_106474-00004"
    }
  }, [_vm._v("In Thy Will is My Peace … The words from Dante swam into his mind. They seemed to swim out of the snow which was teeming beyond the window. He imagined the universe of Dante like a watch. The clock said five in the morning. He felt cold and the light was beginning to azure the window. The street outside was empty of people and traffic. There was no one alive in the world but himself. The lamps cast their glare over the street. They brooded over their own haloes all night.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106474-00005"
    }
  }, [_vm._v("When he looked again the whistling was changing to a rattling. He held one cold hand in his, locking it. The head fell back on the pillow, the mouth gaping wide like the mouth of a landed fish, the eyes staring irretrievably beyond him. The one-barred electric fire hummed in a corner of the room, a deep and raw red wound. His copy of Dante fell from his hand and lay on top of the red woollen rug at the side of the bed stained with milk and soup. He seemed to be on a space ship upside down and seeing coming towards him another space ship shaped like a black mediaeval helmet in all that azure. On board the space ship there was at least one man encased in a black rubber suit but he could not see the face. The man was busy either with a rope which he would fling to him or with a gun which he would fire at him. The figure seemed squat and alien like an Eskimo.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106474-00006"
    }
  }, [_vm._v("And all the while the window azured and the body was like a log, the mouth twisted where all the breath had left it. It lolled on one side of the pillow. Death was not dignified. A dead face showed the pain of its dying, what it had struggled through to become a log. He thought, weeping, this is the irretrievable centre where there is no foliage and no metaphor. At this time poetry is powerless. The body looked up at him blank as a stone with the twisted mouth. It belonged to no one that he had ever known.")])]), _c('p', {
    attrs: {
      "id": "rw-p_106474-00008"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("The copy of Dante seemed to have fallen into an abyss. It was lying on the red rug as if in a fire. Yet he himself was so cold and numb. Suddenly he began to be shaken by tremors though his face remained cold and without movement. The alien azure light was growing steadily, mixed with the white glare of the snow. The landscape outside the window was not a human landscape. The body on the bed was not human.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_106474-00009"
    }
  }, [_vm._v("The tears started to seep slowly from his eyes. In his right hand he found he was holding a small golden watch which he had picked up. He couldn’t remember picking it up. He couldn’t even hear its ticking. It was a delicate mechanism, small and golden. He held it up to his ear and the tears came, in the white and bluish glare. Through the tears he saw the watch and the copy of Dante lying on the red rug and beyond that again the log which seemed unchanging though it would change since everything changed.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106474-00010"
    }
  }, [_vm._v("And he knew that he himself would change though he could not think of it at the moment. He knew that he would change and the log would change and it was this which more than anything made him cry, to think of what the log had been once, a suffering body, a girl growing up and marrying and bearing children. It was so strange that the log could have been like that. It was so strange that the log had once been chequered like a draughtsboard, that it had called him into dinner, that it had been sleepless at night thinking of the future.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106474-00011"
    }
  }, [_vm._v("So strange was it, so irretrievable, that he was shaken as if by an earthquake of pathos and pity. He could not bring himself to look at the Dante; he could only stare at the log as if expecting that it would move or speak. But it did not. It was concerned only with itself. The twisted mouth as if still gasping for air made no promises and no concessions.")])]), _c('p', {
    attrs: {
      "id": "rw-p_106474-00012"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("Slowly as he sat there he was aware of a hammering coming from outside the window and aware also of blue lightning flickering across the room. He had forgotten about the workshop. He walked over to the window and saw men with helmets bending over pure white flame. The blue flashes were cold and queer as if they came from another world. At the same time he heard unintelligible shoutings from the people involved in the work and saw a visored head ")]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("turning to look behind it. Beyond it steadied the sharp azure of the morning. And in front of it he saw the drifting flakes of snow. He looked down at the Dante with his bruised face and felt the hammer blows slamming the lines together, making the universe, holding a world together where people shouted out of a blue light. And the hammer seemed to be beating the log into a vase, into marble, into flowers made of blue rock, into the hardest of metaphors.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aab7dc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675644_chapter_01.vue
// module id = 69
// module chunks = 0